import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";

// Public

import NotFound from "./pages/public/NotFound";

// Admin
import { AdminDashboard } from "./layouts";
import CoomingSoon from "./pages/public/CoomingSoon";

import WeeklySchedule from "./pages/users/admin/calendar/calendarApo";
import ClientDashboard from "./layouts/clientDashboard";
import PrivateRouteAdmin from "./privateRoutes/PrivateRouteAdmin";
import PrivateRouteClient from "./privateRoutes/PrivateRoute";
import Votes from "./pages/public/estadisticaVotaciones";
import Formulario from "./pages/public/Formulario";

import Votar from "./pages/public/votar";
import EstadisticaVotaciones from "./pages/public/estadisticaVotaciones";

const App = () => {
  return (
    <main className="bg-[#F5F4F2] ">
      <Router>
        <Routes>
          <Route path="/" element={<CoomingSoon />} />
          <Route path="/votes" element={<Votes/>}  />
          <Route path="/formulario" element={<Formulario/>} />
          <Route path="/votar" element={<Votar/>} />
          <Route path="/estadistica" element={<EstadisticaVotaciones/>} />
          <Route
            path="/admin/*"
            element={
              <PrivateRouteClient allowedRoles={["Admin", "Client"]}>
                <AdminDashboard />
              </PrivateRouteClient>
            }
          />
          <Route
            path="/client/*"
            element={
              <PrivateRouteClient allowedRoles={["Client"]}>
                <ClientDashboard />
              </PrivateRouteClient>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
      <ToastContainer autoClose={1500} pauseOnHover={false} />
    </main>
  );
};

export default App;
